<template>
    <div>
        <div v-if="value.relatedPrescription?.rxNumber || value.store?.id" class="mb-3">
            <h6>Preview</h6>
            <div class="msg-bubble">
                <b-spinner v-if="loadingPreview" small />
                <template v-else>{{ messagePreview }}</template>
            </div>

            <small v-if="messagePreview?.length" class="text-muted">
                <strong>{{ messagePreview.length }} characters</strong>
                <template v-if="messagePreview.length > 160">
                    (may display as multiple messages)
                </template>
            </small>
        </div>

        <b-form-group v-if="!value.requiresPrescription">
            <SearchComponent :key="value.store?.id" v-model="value.store" label="Store" search-u-r-l="/Store"
                prepopulate :required="true" :autoselect="true" :disabled="!!value.relatedPrescription?.rxNumber" />
        </b-form-group>

        <b-form-group>
            <SearchComponent v-model="value.relatedPrescription" label="Related Prescription"
                :search-u-r-l="'/Patient/' + patient.id + '/prescriptions'" :required="value.requiresPrescription"
                :clearable="!value.requiresPrescription" prepopulate class="mb-0" />
            <small v-if="value.relatedPrescription?.programName">Program: {{ value.relatedPrescription?.programName }}</small>
        </b-form-group>
    </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import SearchComponent from '../SearchComponent.vue';
import { CustomTextMessageTemplate } from '@/models/CustomTextMessageTemplate';
import { Patient } from '@/models/Patient';
import axios from 'axios';
import { Store } from '@/models/Store';

@Component({
    components: {
        SearchComponent
    }
})
export default class CustomTextMessageTemplateSend extends Vue {
    @Prop({ required: true }) protected value!: CustomTextMessageTemplate;
    @Prop({ required: true }) protected patient!: Patient;

    protected messagePreview = "";
    protected loadingPreview = false;

    @Watch("value.relatedPrescription")
    @Watch("value.store")
    async getMessagePreview() {
        try {
            this.loadingPreview = true;
            const rxId = this.value.relatedPrescription?.rxNumber ? this.value.relatedPrescription?.rxID : "";
            const storeId = rxId ? this.value.relatedPrescription!.storeID : this.value.store?.id;

            if (!storeId) throw "No store selected";

            if (!this.value.store?.id) this.value.store = Object.assign(new Store(), { id: storeId });

            const resp = await axios.get(`/CustomTextMessage/preview/${this.value.id}/${this.patient.id}/${storeId ?? 0}${rxId ? `/${rxId}` : ""}`);
            this.messagePreview = resp.data;
        } catch (err) {
            this.messagePreview = "Can't generate a preview.";
            console.error(err);
        } finally {
            this.loadingPreview = false;
        }
    }

}

</script>